import { createQueryParams, handleAPIResponse } from '@/@shared/api/handlers/apiResponse';
import { contentFetcher } from '@/model/openAPI/content-server/instance';
import {
	VideoController_test_Response,
	VideoController_uploadVideo_Params,
	VideoController_uploadVideo_Body,
	VideoController_uploadVideo_Response,
	VideoController_uploadVideo_RO,
	VideoController_uploadTournamentVideo_Params,
	VideoController_uploadTournamentVideo_Body,
	VideoController_uploadTournamentVideo_Response,
	VideoController_uploadTournamentVideo_RO,
	VideoController_uploadArcadeVideo_Body,
	VideoController_uploadArcadeVideo_Response,
	VideoController_uploadArcadeVideo_RO,
	VideoController_deleteVideo_Params,
	VideoController_deleteVideo_Response,
	VideoController_modifyVideo_Params,
	VideoController_modifyVideo_Body,
	VideoController_modifyVideo_Response,
	VideoController_modifyVideo_RO,
	VideoController_getVideoInfo_Params,
	VideoController_getVideoInfo_Response,
	VideoController_getVideoInfo_RO,
	VideoController_getUserVideoList_Params,
	VideoController_getUserVideoList_Response,
	VideoController_getUserVideoList_RO,
	VideoController_boostVideo_Params,
	VideoController_boostVideo_Body,
	VideoController_boostVideo_Response,
	VideoController_likeVideo_Params,
	VideoController_likeVideo_Body,
	VideoController_likeVideo_Response,
	VideoController_getHotDanceVideoList_Params,
	VideoController_getHotDanceVideoList_Response,
	VideoController_getHotDanceVideoList_RO,
	VideoController_getHashtagVideoList_Params,
	VideoController_getHashtagVideoList_Response,
	VideoController_getHashtagVideoList_RO,
	VideoController_getDanceBestVideoList_Params,
	VideoController_getDanceBestVideoList_Response,
	VideoController_getDanceBestVideoList_RO,
	VideoController_getDanceVideoList_Params,
	VideoController_getDanceVideoList_Response,
	VideoController_getDanceVideoList_RO,
	VideoController_getArtistVideoList_Params,
	VideoController_getArtistVideoList_Response,
	VideoController_getArtistVideoList_RO,
	VideoController_getFeedVideoList_Params,
	VideoController_getFeedVideoList_Response,
	VideoController_getFeedVideoList_RO,
	VideoController_getFollowerVideoList_Params,
	VideoController_getFollowerVideoList_Response,
	VideoController_getFollowerVideoList_RO,
	VideoController_changeVideoOption_Params,
	VideoController_changeVideoOption_Body,
	VideoController_changeVideoOption_Response,
	VideoController_shareVideo_Params,
	VideoController_shareVideo_Response,
	VideoController_shareVideo_RO,
	VideoController_checkVideoAlive_Params,
	VideoController_checkVideoAlive_Response,
	VideoController_checkVideoAlive_RO,
	VideoController_getBestDancerVideoList_Params,
	VideoController_getBestDancerVideoList_Response,
	VideoController_getBestDancerVideoList_RO,
	VideoController_watchVideo_Body,
	VideoController_watchVideo_Response,
	VideoController_getTournamentMatchVideoList_Params,
	VideoController_getTournamentMatchVideoList_Response,
	VideoController_getTournamentMatchVideoList_RO,
	VideoController_getTournamentBestVideoList_Params,
	VideoController_getTournamentBestVideoList_Response,
	VideoController_getTournamentBestVideoList_RO,
	VideoController_getTournamentChampionVideoList_Params,
	VideoController_getTournamentChampionVideoList_Response,
	VideoController_getTournamentChampionVideoList_RO,
	VideoController_getTournamentChampionVideoWebList_Params,
	VideoController_getTournamentChampionVideoWebList_Response,
	VideoController_getTournamentChampionVideoWebList_RO,
	VideoController_getTournamentVideoListWeb_Params,
	VideoController_getTournamentVideoListWeb_Response,
	VideoController_getTournamentVideoListWeb_RO,
	VideoController_getTournamentVideoList_Params,
	VideoController_getTournamentVideoList_Response,
	VideoController_getTournamentVideoList_RO,
	VideoController_checkVideoAliveInternal_Params,
	VideoController_checkVideoAliveInternal_Response,
	VideoController_getVideoListInfo_Params,
	VideoController_getVideoListInfo_Body,
	VideoController_getVideoListInfo_Response,
	VideoController_getVideoListInfo_RO,
	VideoController_tempGetVideoListInfo_Params,
	VideoController_tempGetVideoListInfo_Body,
	VideoController_tempGetVideoListInfo_Response,
	VideoController_tempGetVideoListInfo_RO,
	VideoController_getTournamentProfileVideoList_Params,
	VideoController_getTournamentProfileVideoList_Response,
	VideoController_getTournamentProfileVideoList_RO,
	VideoController_updateTournamentVideoVisibility_Params,
	VideoController_updateTournamentVideoVisibility_Body,
	VideoController_updateTournamentVideoVisibility_Response,
} from '@/domains/content/types/validated';

// openapi-fetch HTTP 메서드들 destructuring (싱글톤 인스턴스)
const { GET, POST, PUT, PATCH, DELETE } = contentFetcher;

/**
 * test 조회
 */
export const fetchVideoTest = async () => {
	return handleAPIResponse<VideoController_test_Response>(GET('/video/test'));
};

/**
 * video 등록
 */
export const createVideo = async (
	params: VideoController_uploadVideo_Params,
	body: VideoController_uploadVideo_Body
) => {
	return handleAPIResponse<VideoController_uploadVideo_Response>(
		POST('/video', {
			params,
			body,
		})
	);
};

/**
 * tournament 등록
 */
export const createVideoTournament = async (
	params: VideoController_uploadTournamentVideo_Params,
	body: VideoController_uploadTournamentVideo_Body
) => {
	return handleAPIResponse<VideoController_uploadTournamentVideo_Response>(
		POST('/video/tournament', {
			params,
			body,
		})
	);
};

/**
 * arcade 등록
 */
export const createVideoArcade = async (body: VideoController_uploadArcadeVideo_Body) => {
	return handleAPIResponse<VideoController_uploadArcadeVideo_Response>(
		POST('/video/arcade', {
			body,
		})
	);
};

/**
 * video 삭제
 */
export const removeVideoId = async (params: VideoController_deleteVideo_Params) => {
	return handleAPIResponse<VideoController_deleteVideo_Response>(
		DELETE('/video/{videoId}', {
			params,
		})
	);
};

/**
 * video 수정
 */
export const modifyVideoId = async (
	params: VideoController_modifyVideo_Params,
	body: VideoController_modifyVideo_Body
) => {
	return handleAPIResponse<VideoController_modifyVideo_Response>(
		PATCH('/video/{videoId}', {
			params,
			body,
		})
	);
};

/**
 * info 조회
 */
export const fetchVideoIdInfo = async (params: VideoController_getVideoInfo_Params) => {
	return handleAPIResponse<VideoController_getVideoInfo_Response>(
		GET('/video/{videoId}/info', {
			params,
		})
	);
};

/**
 * video 조회
 */
export const fetchVideoUserId = async (params: VideoController_getUserVideoList_Params) => {
	return handleAPIResponse<VideoController_getUserVideoList_Response>(
		GET('/video/user/{userId}', {
			params,
		})
	);
};

/**
 * boost 등록
 */
export const createVideoIdBoost = async (
	params: VideoController_boostVideo_Params,
	body: VideoController_boostVideo_Body
) => {
	return handleAPIResponse<VideoController_boostVideo_Response>(
		POST('/video/{videoId}/boost', {
			params,
			body,
		})
	);
};

/**
 * like 수정
 */
export const modifyVideoIdLike = async (
	params: VideoController_likeVideo_Params,
	body: VideoController_likeVideo_Body
) => {
	return handleAPIResponse<VideoController_likeVideo_Response>(
		PATCH('/video/{videoId}/like', {
			params,
			body,
		})
	);
};

/**
 * dance 조회
 */
export const fetchVideoHotDance = async (params: VideoController_getHotDanceVideoList_Params) => {
	return handleAPIResponse<VideoController_getHotDanceVideoList_Response>(
		GET('/video/hot/dance', {
			params,
		})
	);
};

/**
 * video 조회
 */
export const fetchVideoHashtagId = async (params: VideoController_getHashtagVideoList_Params) => {
	return handleAPIResponse<VideoController_getHashtagVideoList_Response>(
		GET('/video/hashtag/{hashtagId}', {
			params,
		})
	);
};

/**
 * best 조회
 */
export const fetchVideoDanceIdBest = async (params: VideoController_getDanceBestVideoList_Params) => {
	return handleAPIResponse<VideoController_getDanceBestVideoList_Response>(
		GET('/video/dance/{danceId}/best', {
			params,
		})
	);
};

/**
 * video 조회
 */
export const fetchVideoDanceId = async (params: VideoController_getDanceVideoList_Params) => {
	return handleAPIResponse<VideoController_getDanceVideoList_Response>(
		GET('/video/dance/{danceId}', {
			params,
		})
	);
};

/**
 * video 조회
 */
export const fetchVideoArtistId = async (params: VideoController_getArtistVideoList_Params) => {
	return handleAPIResponse<VideoController_getArtistVideoList_Response>(
		GET('/video/artist/{artistId}', {
			params,
		})
	);
};

/**
 * feed 조회
 */
export const fetchVideoFeed = async (params: VideoController_getFeedVideoList_Params) => {
	return handleAPIResponse<VideoController_getFeedVideoList_Response>(
		GET('/video/feed', {
			params,
		})
	);
};

/**
 * follower 조회
 */
export const fetchVideoFollower = async (params: VideoController_getFollowerVideoList_Params) => {
	return handleAPIResponse<VideoController_getFollowerVideoList_Response>(
		GET('/video/follower', {
			params,
		})
	);
};

/**
 * option 수정
 */
export const modifyVideoIdOption = async (
	params: VideoController_changeVideoOption_Params,
	body: VideoController_changeVideoOption_Body
) => {
	return handleAPIResponse<VideoController_changeVideoOption_Response>(
		PATCH('/video/{videoId}/option', {
			params,
			body,
		})
	);
};

/**
 * dynamiclink 조회
 */
export const fetchVideoIdDynamiclink = async (params: VideoController_shareVideo_Params) => {
	return handleAPIResponse<VideoController_shareVideo_Response>(
		GET('/video/{videoId}/dynamiclink', {
			params,
		})
	);
};

/**
 * alive 조회
 */
export const fetchVideoIdAlive = async (params: VideoController_checkVideoAlive_Params) => {
	return handleAPIResponse<VideoController_checkVideoAlive_Response>(
		GET('/video/{videoId}/alive', {
			params,
		})
	);
};

/**
 * dancer 조회
 */
export const fetchVideoBestDancer = async (params: VideoController_getBestDancerVideoList_Params) => {
	return handleAPIResponse<VideoController_getBestDancerVideoList_Response>(
		GET('/video/best/dancer', {
			params,
		})
	);
};

/**
 * watch 등록
 */
export const createVideoWatch = async (body: VideoController_watchVideo_Body) => {
	return handleAPIResponse<VideoController_watchVideo_Response>(
		POST('/video/watch', {
			body,
		})
	);
};

/**
 * video 조회
 */
export const fetchVideoTournamentMatchId = async (params: VideoController_getTournamentMatchVideoList_Params) => {
	return handleAPIResponse<VideoController_getTournamentMatchVideoList_Response>(
		GET('/video/tournament/match/{matchId}', {
			params,
		})
	);
};

/**
 * best 조회
 */
export const fetchVideoTournamentIdBest = async (params: VideoController_getTournamentBestVideoList_Params) => {
	return handleAPIResponse<VideoController_getTournamentBestVideoList_Response>(
		GET('/video/tournament/{tournamentId}/best', {
			params,
		})
	);
};

/**
 * champion 조회
 */
export const fetchVideoTournamentChampion = async (params: VideoController_getTournamentChampionVideoList_Params) => {
	return handleAPIResponse<VideoController_getTournamentChampionVideoList_Response>(
		GET('/video/tournament/champion', {
			params,
		})
	);
};

/**
 * web 조회
 */
export const fetchVideoTournamentChampionWeb = async (
	params: VideoController_getTournamentChampionVideoWebList_Params
) => {
	return handleAPIResponse<VideoController_getTournamentChampionVideoWebList_Response>(
		GET('/video/tournament/champion/web', {
			params,
		})
	);
};

/**
 * web 조회
 */
export const fetchVideoTournamentIdWeb = async (params: VideoController_getTournamentVideoListWeb_Params) => {
	return handleAPIResponse<VideoController_getTournamentVideoListWeb_Response>(
		GET('/video/tournament/{tournamentId}/web', {
			params,
		})
	);
};

/**
 * round 조회
 */
export const fetchVideoTournamentIdRound = async (params: VideoController_getTournamentVideoList_Params) => {
	return handleAPIResponse<VideoController_getTournamentVideoList_Response>(
		GET('/video/tournament/{tournamentId}/round', {
			params,
		})
	);
};

/**
 * alive 조회
 */
export const fetchVideoInternalIdAlive = async (params: VideoController_checkVideoAliveInternal_Params) => {
	return handleAPIResponse<VideoController_checkVideoAliveInternal_Response>(
		GET('/video/internal/{videoId}/alive', {
			params,
		})
	);
};

/**
 * info 등록
 */
export const createVideoListInfo = async (
	params: VideoController_getVideoListInfo_Params,
	body: VideoController_getVideoListInfo_Body
) => {
	return handleAPIResponse<VideoController_getVideoListInfo_Response>(
		POST('/video/list/info', {
			params,
			body,
		})
	);
};

/**
 * info 등록
 */
export const createVideoTempListInfo = async (
	params: VideoController_tempGetVideoListInfo_Params,
	body: VideoController_tempGetVideoListInfo_Body
) => {
	return handleAPIResponse<VideoController_tempGetVideoListInfo_Response>(
		POST('/video/temp/list/info', {
			params,
			body,
		})
	);
};

/**
 * video 조회
 */
export const fetchVideoUserIdTournamentId = async (params: VideoController_getTournamentProfileVideoList_Params) => {
	return handleAPIResponse<VideoController_getTournamentProfileVideoList_Response>(
		GET('/video/user/{userId}/tournament/{tournamentId}', {
			params,
		})
	);
};

/**
 * visibility 수정
 */
export const modifyVideoTournamentVisibility = async (
	params: VideoController_updateTournamentVideoVisibility_Params,
	body: VideoController_updateTournamentVideoVisibility_Body
) => {
	return handleAPIResponse<VideoController_updateTournamentVideoVisibility_Response>(
		PATCH('/video/tournament/visibility', {
			params,
			body,
		})
	);
};
